/**
 * medilawyer_session_id 쿠키 — 챗봇 카운트 키의 일부 (기획 03 §3.2).
 *
 * 한 브라우저 = 한 cookie_id. 1년 유지. SameSite=Lax 로 same-origin POST 안전.
 * IP 와 함께 서버에서 counter_key 로 결합되어 무료 한도 카운트에 사용.
 */
const COOKIE_NAME = 'medilawyer_session_id';
const COOKIE_MAX_AGE_SEC = 60 * 60 * 24 * 365; // 1년

function readCookie(name) {
  if (typeof document === 'undefined') return null;
  const entry = document.cookie.split('; ').find((row) => row.startsWith(name + '='));
  return entry ? decodeURIComponent(entry.split('=')[1]) : null;
}

function writeCookie(name, value) {
  document.cookie = [
    `${name}=${encodeURIComponent(value)}`,
    `Max-Age=${COOKIE_MAX_AGE_SEC}`,
    'Path=/',
    'SameSite=Lax',
  ].join('; ');
}

function generateCookieId() {
  const arr = new Uint8Array(16);
  crypto.getRandomValues(arr);
  return Array.from(arr, (b) => b.toString(16).padStart(2, '0')).join('');
}

export function ensureSessionCookie() {
  let id = readCookie(COOKIE_NAME);
  if (!id) {
    id = generateCookieId();
    writeCookie(COOKIE_NAME, id);
  }
  return id;
}
